import { FC } from "react";
import { useSelector } from "react-redux";

import ScreenLoader from "components/ScreenLoader/ScreenLoader";
import CreatePhoneNumber from "containers/CreatePhoneNumber/CreatePhoneNumber";
import VerifySession from "containers/VerifySession/VerifySession";
import { RootState } from "store";
import { getIsIdentified } from "store/selectors";

import { withTransaction } from "@elastic/apm-rum-react";
import { isEmpty, some } from "lodash-es";

const VerifySessionRoute: FC = () => {
  // const { sessionVerificationChecked } = useSelector((state: RootState) => state.authentication);
  const profile = useSelector((state: RootState) => state.profile);
  const { phoneNumbers, preVerifiedDataFetched, isLoadingPreVerifiedData } = profile;
  const hasPhone = useSelector((state: RootState) => !isEmpty(state.profile.phoneNumbers));
  const hasActivePhoneNumber = some(phoneNumbers, ["status", "active"]);
  const isIdentified = useSelector(getIsIdentified);

  if (!preVerifiedDataFetched) {
    return <ScreenLoader />;
  }

  if (!hasPhone && !isIdentified) {
    if (preVerifiedDataFetched && isLoadingPreVerifiedData) {
      return <ScreenLoader />;
    }
    return <CreatePhoneNumber />;
  }

  return <VerifySession type={hasActivePhoneNumber ? "session" : "phone"} />;
};

export default withTransaction("VerifySessionRoute", "component")(VerifySessionRoute);
